export default __webpack_public_path__ + "static/media/sumIcon.6d6fb6b5.svg";